import { render, staticRenderFns } from "./Sortable.vue?vue&type=template&id=8ee87136&"
import script from "./Sortable.vue?vue&type=script&lang=js&"
export * from "./Sortable.vue?vue&type=script&lang=js&"
import style0 from "./Sortable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports